import { Dialog } from "@headlessui/react"
import { FC } from "react"
import * as React from "react"
import { KButton, KSpan, KTitleSpan } from "kahuna-base-react-components"
import { lang } from "../../../../../constants/languages"

type ErrorModalProps = {
  text?: string
  setText: (text?: string) => void
}
const ErrorModal: FC<ErrorModalProps> = (props) => {
  const { text, setText } = props

  const renderOpen = () => {
    if (text) return true
    else return false
  }

  const isUrl = (line: string) => /^https?:\/\/\S+$/.test(line.trim())

  const renderText = () => {
    try {
      return (
        text?.split("\\n").map((line, index) =>
          isUrl(line.trim()) ? (
            <a key={index} href={line.trim()} target="_blank" rel="noopener noreferrer">
              <KSpan text={line} color="#2376ad" fontWeight={500} />
            </a>
          ) : (
            <KSpan key={index} text={line} color="#111" fontWeight={500} />
          )
        ) || ""
      )
    } catch (_) {
      return <KSpan text={text ? JSON.stringify(text) : ""} />
    }
  }

  return (
    <Dialog open={renderOpen()} onClose={() => setText(undefined)} className="relative z-50">
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div
          className="mt-10 bg-white elev-b-sm rounded-lg overflow-auto"
          style={{ maxHeight: "80vh", width: "600px" }}
        >
          <div className={`bg-gray-50 text-xs text-gray-500 font-medium uppercase border-b flex justify-center`}>
            <KTitleSpan text={lang.common.error} fontSize={24} />
          </div>
          <div className="w-full flex flex-col p-4 text-center gap-1">{renderText()}</div>
          <div className="w-full m-auto flex-column p-4 text-center">
            <KSpan text={lang.common.contact_customer_support} fontStyle="italic" />
          </div>
          <div className="flex gap-4 p-4 px-8">
            <KButton text={lang.common.close} background="transparent" onClick={() => setText(undefined)} />
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorModal
